(function($) {

	'use strict';

	var init = function() {

		if($('.fp-hero__visual__slider').length > 0) {
			startHeroSlider();
		}

	};

	var startHeroSlider = function() {

		$('.fp-hero__visual__slider').owlCarousel({
			loop: true,
			margin: 0,
			autoplay: true,
			autoplayTimeout: 5000,
			items: 1,
			center: true,
			mouseDrag: true,
			touchDrag: true,
			smartSpeed: 1300,
			dots: true,
			autoplayHoverPause: true,
			responsive: {
				0: {
					nav: false,
				},
				992: {
					nav: true,
				}
			}
		});
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
